<template>
  <div class="bk-client">
    <v-btn fixed dark fab bottom right color="pink" class="mb-12" @click="showClientDetails()">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-container>
      <v-row dense class="mx-auto">
        <v-col cols="12" sm="6" lg="4" xl="3" v-for="(client) in filteredClients" :key="client.cid">
          <client-item :client="client" @showClientDetails="showClientDetails"></client-item>
        </v-col>
        <v-col v-if="filteredClients.length == 0">
          <v-alert dense outlined type="info" color="orange" elevation="12">
            <v-list-item-title>No clients to display</v-list-item-title>
            <v-list-item-subtitle>Click the + button below to add a new client!</v-list-item-subtitle>
          </v-alert>
        </v-col>
      </v-row>
    </v-container>

    <template>
      <v-row justify="center">
        <v-dialog v-model="showClient" scrollable persistent max-width="600px">
          <DialogClient :item="obj" />
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>

<script>
import { storeprops } from "@/store/helpers.js";
import DialogClient from "@/components/dialogs/DialogClient";
import ClientItem from "@/components/client/ClientItem";

export default {
  components: { DialogClient, ClientItem },
  data: () => ({
    showClient: false,
    obj: {}
  }),
  computed: {
    ...storeprops,
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },
  watch: {},
  methods: {
    showClientDetails(client) {
      let inNewMode = client == null;
      let hasProjects = false;

      // check if this client has projects associated with it
      if (client) {
        let projects = this.$store.getters.getRelatedProjects(client.cid);
        hasProjects = projects.length > 0;
      }

      this.obj = new objDataClient();
      this.obj.canDelete = !hasProjects;
      this.obj.inNewMode = inNewMode;
      this.obj.client = inNewMode ? {} : JSON.parse(JSON.stringify(client));
      this.obj.closeDialog = () => (this.showClient = false);
      this.obj.updateClient = client2 => {
        if (inNewMode) this.$store.dispatch("createClient", client2);
        else this.$store.dispatch("updateClient", client2);
        this.showClient = false;
      };
      this.obj.deleteClient = client2 => {
        this.$store.dispatch("deleteClient", client2);
        this.showClient = false;
      };
      this.showClient = true;
    }
  }
};

class objDataClient {
  client = null;
  canDelete = false;
  inNewMode = false;
  updateClient = null;
  deleteClient = null;
  closeDialog = null;
}
</script>


<style lang="scss" scoped>
.bk-client {
  //background: #9b9a9c; // #45374d !important;
}

.bk-client2 {
  background: red; // #5d4e7a;
}

// .one-edge-shadow {
//   -webkit-box-shadow: 0 8px 6px -6px black;
//   -moz-box-shadow: 0 8px 6px -6px black;
//   box-shadow: 0 8px 6px -6px black;
// }
</style>
